export function buildPrintWorksheetUrl(examId: string, options?: { edit?: boolean }): string {
  const base = `/studio/print/${encodeURIComponent(examId)}`;
  return options?.edit ? `${base}?edit=1` : base;
}
